import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

import type { ListingPage } from '../model';
import { selectListing } from './listing';

export const selectPageName = (
  state: SpartacuxProductDiscoveryDomainState,
): ListingPage | null | undefined => selectListing(state)?.pageName;
